module.exports = __webpack_public_path__ + "img/logohaitunjinfu.e5e002cd.png";